const initTabPanel = () => {
    document.addEventListener('DOMContentLoaded', function() {
        const cbTabs = document.querySelectorAll('[data-cb-tab]');
        if (cbTabs.length > 0) {
            cbTabs.forEach(tab => {
                tab.addEventListener('click', function(e) {
                    e.preventDefault();
                    const wrapper = this.closest('.cb-tabs');
                    wrapper.querySelectorAll('.cb-tab').forEach(t => t.classList.remove('active'));
                    wrapper.querySelectorAll('.cb-tab-pane').forEach(p => p.classList.remove('active'));
                    this.parentElement.classList.add('active');
                    const target = wrapper.querySelector(this.getAttribute('href'));
                    if(target) target.classList.add('active');
                });
            });
        }
    });
};

export default initTabPanel;